import { CoreContext, CoreContextType } from "PFCore/core_context";
import { useCurrentAccount } from "PFCore/hooks/queries/account/use_current_account";
import i18n from "PFCore/i18n";
import { PropsWithChildren, useMemo } from "react";
import { I18nextProvider } from "react-i18next";

import { getAccountDateFormatData } from "./helpers";

export const CoreContextProvider = ({ children }: PropsWithChildren) => {
  const { data: currentAccount } = useCurrentAccount();
  const { dateFormat, isAM } = getAccountDateFormatData(currentAccount);

  const value = useMemo<CoreContextType>(
    () => ({
      dateFormat,
      isAM
    }),
    [dateFormat, isAM]
  );

  return (
    <CoreContext.Provider value={value}>
      <I18nextProvider i18n={i18n}>{children}</I18nextProvider>
    </CoreContext.Provider>
  );
};
